import { render, staticRenderFns } from "./Numberings.yaml?vue&type=template&id=324fc4c2&component"
import script from "./Numberings.yaml?vue&type=script&lang=ts&component"
export * from "./Numberings.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports